import AccordionProduct from "@/components/Ui/Tools/AccordionProduct/AccordionProduct";
import { removeTags, t } from "@/helper/helper";
import { baseURL, MEDIA_URL } from "@/services/api";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import {
  ICategoryProduct,
  IMeta,
  IProductDetail,
  IProductDetailGeneric,
  IRelateds,
} from "global-types/global.types";
import { GetServerSideProps } from "next";
import Link from "next/link";
import React, { useEffect, useRef, useState } from "react";
import { SITE_NAME, SITE_URL, WHATSAPP_NUMBER, loan } from "@/helper/constant";
import { useRouter } from "next/router";
import ProductSlider from "@/components/Ui/Pages/ProductSlider/ProductSlider";
import NewProduct from "@/components/Ui/Pages/NewProduct/NewProduct";
import ProductDetailCarousel from "@/components/Ui/Pages/ProductDetailCarousel/ProductDetailCarousel";
import nookies from "nookies";
import useBasket from "@/hooks/common/useAddBasket";
import { NextSeo } from "next-seo";
import axios from "axios";
import Image from "next/image";
import useNewProductsAccordingHome from "@/hooks/common/useNewProductsAccordingHome";
import OrderModal from "@/components/Ui/Tools/OrderModal/OrderModal";
import OrderNotStockSuccessModal from "@/components/Ui/Tools/OrderNoStockSuccess/OrderNoStockSuccess";
import styled from "styled-components";
import BuyWithLoanModal from "@/components/Ui/Tools/BuyWithLoanModal/BuyWithLoanModal";
import { ToastContainer } from "react-toastify";

interface Props {
  locale: string;
  slug: string[];
  productData: IProductDetail<
    IProductDetailGeneric<ICategoryProduct, IMeta, IRelateds[]>
  >;
}

export default function ProductDetail({ locale, slug, productData }: Props) {
  const breadCrumbs = useRef<any>([]);

  const [modalShow, setModalShow] = useState<string>("off");

  useEffect(() => {
    breadCrumbs.current = [];
  });

  const getRating = (comments) => {
    if (!comments) return 0;
    let totalStar = 0;
    for (let el of comments) {
      totalStar += el.star;
    }
    return totalStar / (comments?.length || 1);
  };

  const getStars = (rate: number): string[] => {
    const arr: any = [];
    for (let i = 0; i < rate; i++) {
      arr.push(`<svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 0L7.854 3.75205L12 4.35741L9 7.27634L9.708 11.4L6 9.45205L2.292 11.4L3 7.27634L0 4.35741L4.146 3.75205L6 0Z"
        fill="#FFDA93"
      />
    </svg>`);
    }
    return arr;
  };

  const [audioFile, setAudioFile] = useState<string | null>(null);

  const { asPath } = useRouter();

  // api
  const { addCard, isLoadingAddCard } = useBasket();

  const handleAddCard = () => {
    if (!isLoadingAddCard) addCard(productData.data.id);
  };

  const handleOrderNoStock = () => {
    setModalShow("on");
  };

  // news Produts

  const { productsNewHome, isLoadingProductsNewHome } =
    useNewProductsAccordingHome();

  const [dataMountlyPayment, setDataMountlyPayment] = useState<{
    month: number;
    percent: number;
  }>({
    month: 6,
    percent: 9.5,
  });

  const handleDataMountlyPayment = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.currentTarget;

    const mothlyPayment = Number(target.getAttribute("data-monthly-payment"));
    const mothlyPercent = Number(target.getAttribute("data-monthly-percent"));

    setDataMountlyPayment((prev) => ({
      ...prev,
      month: mothlyPayment,
      percent: mothlyPercent,
    }));
  };

  const [isLoan, setIsLoan] = useState<boolean>(false);

  const handleBuyWithLoan = () => {
    setIsLoan((prev) => !prev);
  };

  const [lastPrice, setLastPrice] = useState<any>();

  useEffect(() => {
    if (!productData.data.is_order) {
      if (productData.data.discount_type === "1")
        setLastPrice(productData.data.price - productData.data.discount);
      else
        setLastPrice(
          productData.data.price -
            ((productData.data.price * productData.data.discount) / 100 || 0)
        );
    }
  }, [productData]);

  return (
    <>
      <NextSeo
        title={productData.data.meta_title}
        description={productData?.data?.meta_desc}
        canonical={SITE_URL + "/" + locale + asPath}
        additionalMetaTags={[
          {
            name: "title",
            content: `${
              productData?.data?.meta?.title || productData.data.title
            } | ${SITE_NAME}`,
          },
        ]}
        openGraph={{
          url: SITE_URL + "/" + locale + asPath,
          title: `${
            productData?.data?.meta?.title || productData?.data?.title
          } | ${SITE_NAME}`,
          description:
            productData?.data?.meta?.description?.substring(0, 300) ||
            removeTags(productData?.data?.description).substring(0, 300),
          images: [
            {
              url: productData?.data?.og_img || "",
            },
          ],
          siteName: SITE_NAME,
        }}
      />
      {modalShow === "on" && (
        <OrderModal
          product_id={productData.data.id}
          locale={locale}
          onHide={setModalShow}
        />
      )}

      {modalShow === "success" && (
        <OrderNotStockSuccessModal closeModal={setModalShow} locale={locale} />
      )}
      {isLoan && (
        <BuyWithLoanModal
          locale={locale}
          toggleModal={handleBuyWithLoan}
          loanData={{
            product_id: productData?.data?.id,
            mounth: dataMountlyPayment.month,
          }}
        />
      )}
      <ToastContainer />
      <div className="product-detail-page">
        <div className="breadcrumb">
          <Link href={`/${locale}`}>{t("homePage", locale)}</Link>
          <span className="breadcrumb-seperator" />
          {productData.data.breadcrumb.data.parent
            .slice()
            .reverse()
            .map((item, index) => (
              <Link
                href={`/${locale}/categories/${item.slug}`}
                key={index.toString() + item.name}
              >
                {item.name}
              </Link>
            ))}
          <span className="breadcrumb-seperator" />
          <Link
            href={`/${locale}/product-list/${productData.data.breadcrumb.data.slug}`}
            className="capital"
          >
            {productData.data.breadcrumb.data.name}
          </Link>
          <Link
            href={`/${locale}/${slug.toString().replaceAll(",", "/")}`}
            className="capital"
          >
            {productData.data.title}
          </Link>
        </div>
        <div className="product-detail">
          <div className="product-detail_carousel">
            <div className="produc-detail-carousel-inner-child">
              <div className="product-detail-carousel-inner">
                <ProductDetailCarousel data={productData} />
              </div>
              {productData.data.video && (
                <div>
                  <iframe
                    src={`https://www.youtube.com/embed/${productData.data.video}`}
                    title="YouTube video player"
                    className="product-inner-video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              )}
            </div>
            <div className="product-detail_content">
              <div id="zoom"></div>
              <div className="features">
                {productData.data.is_new ? (
                  <div className="new-sale">
                    <div className="icon-background">
                      <svg
                        width={10}
                        height={14}
                        viewBox="0 0 10 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 8.63636C7.20914 8.63636 9 6.9269 9 4.81818C9 2.70946 7.20914 1 5 1C2.79086 1 1 2.70946 1 4.81818C1 6.9269 2.79086 8.63636 5 8.63636Z"
                          stroke="white"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M2.83433 8.03091L2.1429 13L5.00004 11.3636L7.85718 13L7.16576 8.02545"
                          stroke="white"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    {t("new", locale)}
                  </div>
                ) : (
                  <></>
                )}

                {productData.data.is_bestseller ? (
                  <div className="most-sale">
                    <div className="icon-background">
                      <svg
                        width={14}
                        height={14}
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.04837 12.9999H2.21935C1.89596 12.9999 1.58581 12.8735 1.35714 12.6485C1.12847 12.4234 1 12.1182 1 11.7999V7.59996C1 7.2817 1.12847 6.97648 1.35714 6.75144C1.58581 6.52639 1.89596 6.39997 2.21935 6.39997H4.04837M8.31609 5.19997V2.79999C8.31609 2.3226 8.12339 1.86477 7.78038 1.5272C7.43737 1.18964 6.97215 1 6.48707 1L4.04837 6.39997V12.9999H10.9255C11.2196 13.0032 11.5049 12.9018 11.729 12.7143C11.9531 12.5269 12.1007 12.2661 12.1448 11.9799L12.9862 6.57996C13.0127 6.40798 13.0009 6.23238 12.9516 6.06532C12.9024 5.89826 12.8168 5.74375 12.7008 5.61248C12.5848 5.48121 12.4412 5.37633 12.2799 5.3051C12.1187 5.23388 11.9436 5.198 11.7668 5.19997H8.31609Z"
                          stroke="white"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    {t("bestSeller", locale)}
                  </div>
                ) : null}
                {productData.data.guarantee &&
                  Number(productData.data.guarantee) > 0 && (
                    <div className="warranty">
                      <div className="icon-background">
                        <svg
                          width={12}
                          height={14}
                          viewBox="0 0 12 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6 13C6 13 11 10.6 11 7V2.8L6 1L1 2.8V7C1 10.6 6 13 6 13Z"
                            stroke="white"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      {/* {productData.data.guarantee}{" "} */}
                      {t("12MonthsWarranty", locale)}
                    </div>
                  )}
                <div className="warrantyx">
                  <div className="icon-background">
                    <img
                      style={{
                        width: 50,
                        marginLeft: 10,
                      }}
                      src="https://abb-bank.az/storage/uploads/files/1626330346_visa-classic-tam-01.png"
                    />
                  </div>
                </div>
                <div className="warrantyx">
                  <div className="icon-background">
                    <img
                      style={{
                        width: 50,
                        marginLeft: 10,
                      }}
                      src={require("@/assets/img/birkart.jpg").default.src}
                    />
                  </div>
                </div>
              </div>
              <div className="product-info">
                <h1 className="product-name">{productData.data.title}</h1>
                <div className="product-statistics">
                  <div className="rating">
                    {getStars(productData.data.rate).map((item, index) => (
                      <span
                        key={item + index.toString()}
                        dangerouslySetInnerHTML={{
                          __html: item,
                        }}
                      />
                    ))}
                  </div>
                  <div className="comment">
                    {productData.data.commentCount} {t("comment", locale)}
                  </div>
                  <a href={`/${locale}/brand/${productData.data.brand.slug}`}>
                    <div className="brand">
                      <div className="img-container">
                        <Image
                          width={400}
                          height={400}
                          src={`${productData.data.brand.logo}`}
                          alt={productData.data.brand.name}
                        />
                      </div>
                      <p className="brand-name">
                        {productData.data.brand.name}
                      </p>
                    </div>
                  </a>
                </div>
                <div className="product-price">
                  <div className="price-section">
                    {!!productData.data.discount_type ? (
                      productData.data.discount &&
                      Number(Math.trunc(productData.data.discount)) > 0 ? (
                        <div className="discount">
                          {Math.trunc(-productData.data.discount)}{" "}
                          {productData.data.discount_type === "1" ? (
                            <svg
                              className="manatIconX"
                              width={33}
                              height={27}
                              viewBox="0 0 33 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M15 26L15.8511 1.03704L18.6596 0L19 24L15 26Z"
                                fill="#FF4C4C"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0 26.7126L3.31441 26.8563C3.37837 10.7044 12.0742 5.37873 16.3559 5.22923C27.9253 5.59751 29.2515 20.3484 29.6856 26.8563L33 27C32.7507 11.4088 24.1817 2.85531 17.1485 3.00185C5.15613 3.42337 0.588832 15.6295 0 26.7126Z"
                                fill="#FF4C4C"
                              />
                            </svg>
                          ) : (
                            "%"
                          )}
                        </div>
                      ) : (
                        <></>
                      )
                    ) : (
                      <></>
                    )}
                    <div className="prices">
                      {!!productData.data.discount_type ? (
                        productData.data.discount &&
                        Number(productData.data.discount) > 0 ? (
                          <div className="old-price">
                            {productData.data.price}{" "}
                            <svg
                              width={33}
                              height={27}
                              viewBox="0 0 33 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="manatIcon"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M15 26L15.8511 1.03704L18.6596 0L19 24L15 26Z"
                                fill="#FF4C4C"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0 26.7126L3.31441 26.8563C3.37837 10.7044 12.0742 5.37873 16.3559 5.22923C27.9253 5.59751 29.2515 20.3484 29.6856 26.8563L33 27C32.7507 11.4088 24.1817 2.85531 17.1485 3.00185C5.15613 3.42337 0.588832 15.6295 0 26.7126Z"
                                fill="#FF4C4C"
                              />
                            </svg>
                          </div>
                        ) : (
                          <></>
                        )
                      ) : (
                        <></>
                      )}
                      <div className="new-price">
                        {!productData.data.is_order ? (
                          productData.data.discount_type === "1" ? (
                            <>
                              {productData.data.price -
                                productData.data.discount}{" "}
                              <svg
                                width={33}
                                height={27}
                                viewBox="0 0 33 27"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="manatIcon"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M15 26L15.8511 1.03704L18.6596 0L19 24L15 26Z"
                                  fill="#FF4C4C"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 26.7126L3.31441 26.8563C3.37837 10.7044 12.0742 5.37873 16.3559 5.22923C27.9253 5.59751 29.2515 20.3484 29.6856 26.8563L33 27C32.7507 11.4088 24.1817 2.85531 17.1485 3.00185C5.15613 3.42337 0.588832 15.6295 0 26.7126Z"
                                  fill="#FF4C4C"
                                />
                              </svg>
                            </>
                          ) : (
                            <>
                              {productData.data.price -
                                ((productData.data.price *
                                  productData.data.discount) /
                                  100 || 0)}{" "}
                              <svg
                                width={33}
                                height={27}
                                viewBox="0 0 33 27"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="manatIcon"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M15 26L15.8511 1.03704L18.6596 0L19 24L15 26Z"
                                  fill="#FF4C4C"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 26.7126L3.31441 26.8563C3.37837 10.7044 12.0742 5.37873 16.3559 5.22923C27.9253 5.59751 29.2515 20.3484 29.6856 26.8563L33 27C32.7507 11.4088 24.1817 2.85531 17.1485 3.00185C5.15613 3.42337 0.588832 15.6295 0 26.7126Z"
                                  fill="#FF4C4C"
                                />
                              </svg>
                            </>
                          )
                        ) : (
                          t("isOrder", locale)
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="product-code">
                    {t("productCode", locale)}:{" "}
                    <span>{productData.data.id}</span>
                  </div>
                </div>
                {productData.data.qty === 0 && !productData.data.is_order ? (
                  <div className="product-stock">{t("soldOut", locale)}</div>
                ) : (
                  <></>
                )}

                {productData.data.sound && (
                  <div className="audioBox">
                    {productData.data.sounds.length !== 0 ? (
                      <div className="selectBox">
                        <select
                          className="changeMp3"
                          onChange={(
                            e: React.ChangeEvent<HTMLSelectElement>
                          ) => {
                            const { value } = e.currentTarget;
                            setAudioFile(value);
                          }}
                        >
                          {productData.data.sounds.map((sound, index) => {
                            if (index > 1) {
                              return (
                                <>
                                  <option value={productData.data.sound}>
                                    1
                                  </option>
                                  <option
                                    key={index.toString() + "sounds"}
                                    value={sound.url}
                                  >
                                    {index + 1}
                                  </option>
                                </>
                              );
                            } else {
                              return (
                                <>
                                  <option value={productData.data.sound}>
                                    1
                                  </option>
                                  <option
                                    key={index.toString() + "sounds"}
                                    value={sound.url}
                                  >
                                    {index + 2}
                                  </option>
                                </>
                              );
                            }
                          })}
                        </select>
                      </div>
                    ) : (
                      ""
                    )}
                    <AudioPlayer
                      style={{
                        borderRadius: "1rem",
                        background: "#f3f3f3",
                        color: "white",
                      }}
                      src={
                        MEDIA_URL +
                        "/" +
                        (!!audioFile ? audioFile : productData.data.sound)
                      }
                    />
                  </div>
                )}
                {!productData.data.is_order ? (
                  <>
                    <div className="calks">
                      <div className="calks__top">
                        {t("seperatlyBuyingCalc", locale)}
                      </div>
                      <div className="calks__span">
                        {t("appliedCondition", locale)}
                      </div>

                      <div className="calks__wr">
                        <Flex>
                          <div className="calks__circles">
                            {loan.map(({ percent, month }) => (
                              <div
                                onClick={handleDataMountlyPayment}
                                className={`calks__circle ${
                                  month === dataMountlyPayment.month
                                    ? "calks__circle--active"
                                    : ""
                                }`}
                                data-monthly-payment={month}
                                data-monthly-percent={percent}
                              >
                                {month} ay{" "}
                              </div>
                            ))}
                          </div>
                        </Flex>
                        <div className="calks__wrt">
                          <span>Aylıq ödəniş</span>
                          <span className="calks-price">
                            <strong className="mountly-payment">
                              {(
                                (lastPrice +
                                  (lastPrice * dataMountlyPayment.percent) /
                                    100) /
                                dataMountlyPayment.month
                              ).toFixed(2)}
                            </strong>
                            <strong>₼</strong>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="product-buttons">
                      <button
                        className={`button add-cart`}
                        onClick={handleAddCard}
                        disabled={
                          !(productData.data.id || productData.data.price) ||
                          productData.data.qty === 0
                        }
                      >
                        {t("addToCart", locale)}
                      </button>

                      <button
                        className={`button add-cart buy-with-loan`}
                        onClick={handleBuyWithLoan}
                        disabled={
                          !(productData.data.id || productData.data.price) ||
                          productData.data.qty === 0
                        }
                      >
                        {t("buyWithLoan", locale)}
                      </button>

                      <a
                        href={`https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=https://promusic.az/${asPath}`}
                        target="_blank"
                        className="whatsapp-btn"
                      >
                        <button className="whatsapp-btn">
                          <svg
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M19.9589 4.00809C17.8539 1.90063 15.0545 0.739517 12.0721 0.738281C5.92662 0.738281 0.925095 5.73967 0.922623 11.8868C0.921799 13.8518 1.43513 15.77 2.41086 17.4608L0.829102 23.2383L6.73961 21.6878C8.36819 22.5762 10.2017 23.0444 12.0676 23.0449H12.0722C18.217 23.0449 23.2191 18.0431 23.2214 11.8957C23.2227 8.9165 22.064 6.1154 19.9589 4.00809ZM12.0721 21.162H12.0683C10.4055 21.1613 8.77469 20.7144 7.35168 19.8703L7.01344 19.6694L3.50606 20.5895L4.44223 17.1698L4.22182 16.8192C3.29416 15.3438 2.80431 13.6384 2.80513 11.8875C2.80705 6.77815 6.96428 2.62134 12.0758 2.62134C14.551 2.62216 16.8778 3.58731 18.6274 5.33894C20.3769 7.09057 21.3399 9.41885 21.3391 11.895C21.3369 17.0048 17.1799 21.162 12.0721 21.162ZM17.1552 14.2215C16.8767 14.082 15.507 13.4083 15.2515 13.3152C14.9964 13.2222 14.8104 13.1759 14.6249 13.4547C14.4391 13.7335 13.9053 14.3611 13.7427 14.5469C13.5801 14.7328 13.4178 14.7561 13.1391 14.6166C12.8605 14.4772 11.9629 14.1829 10.8988 13.2339C10.0707 12.4952 9.5116 11.5829 9.349 11.3041C9.18668 11.0251 9.34763 10.8888 9.47122 10.7356C9.7728 10.3611 10.0748 9.96844 10.1676 9.78264C10.2606 9.59669 10.214 9.43396 10.1443 9.29457C10.0748 9.15518 9.51764 7.78395 9.28555 7.22598C9.05923 6.68298 8.82976 6.75632 8.65865 6.7478C8.49632 6.7397 8.31052 6.73805 8.12471 6.73805C7.93904 6.73805 7.63719 6.80768 7.38176 7.08673C7.12646 7.36564 6.40686 8.03952 6.40686 9.41075C6.40686 10.782 7.40511 12.1067 7.54436 12.2926C7.68361 12.4785 9.50885 15.2924 12.3034 16.499C12.968 16.7863 13.4869 16.9575 13.8916 17.0859C14.559 17.298 15.1661 17.268 15.6462 17.1963C16.1815 17.1163 17.2943 16.5223 17.5267 15.8717C17.7588 15.2209 17.7588 14.6632 17.689 14.5469C17.6195 14.4307 17.4337 14.3611 17.1552 14.2215Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      </a>
                    </div>
                  </>
                ) : (
                  <div className="product-buttons">
                    <button
                      className={`button add-cart`}
                      onClick={handleOrderNoStock}
                    >
                      {t("orderNoStock", locale)}
                    </button>
                  </div>
                )}
              </div>

              <AccordionProduct
                open={true}
                version="acc-side"
                title={t("aboutProduct", locale)}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: productData.data.description,
                  }}
                />
              </AccordionProduct>
              <AccordionProduct
                open={true}
                version="acc-side"
                title={t("buyerReviews", locale)}
              >
                <div className="customer-comments">
                  <div className="comments-header">
                    <p className="count">
                      {t("writeComment", locale)}{" "}
                      <span>{productData.data.comments.length}</span>{" "}
                      {t("writeComment", locale)}
                    </p>
                    <p className="rating">
                      {getRating(productData.data.comments)}{" "}
                      <svg
                        width={12}
                        height={12}
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 0L7.854 3.75205L12 4.35741L9 7.27634L9.708 11.4L6 9.45205L2.292 11.4L3 7.27634L0 4.35741L4.146 3.75205L6 0Z"
                          fill="#FFDA93"
                        />
                      </svg>{" "}
                    </p>
                  </div>
                  {productData.data.comments.map((comment, index) => (
                    <div
                      className="comments-body"
                      key={`${comment.id}-${index}`}
                    >
                      <div className="comment-info">
                        <p className="user-name">{comment.user?.fullName} </p>
                        <div className="raiting-stars">
                          <span>{comment.star}</span>
                          {/* StarRatings */}
                        </div>
                        <p className="date">{comment.created_at}</p>
                      </div>
                      <div className="comment-text">{comment.note}</div>
                    </div>
                  ))}
                </div>
              </AccordionProduct>
            </div>
          </div>
          <div className="related-products">
            {productData?.data.relateds.length !== 0 ? (
              <ProductSlider
                locale={locale}
                title={t("relatedProducts", locale)}
                data={productData.data.relateds}
                slug={`/${locale}/${asPath
                  ?.split("/")
                  ?.slice(0, -1)
                  ?.splice(1)
                  ?.toString()
                  ?.replaceAll(",", "/")}`}
              />
            ) : (
              <></>
            )}
          </div>
          <div className="similar-products">
            {!isLoadingProductsNewHome ? (
              productsNewHome?.data.length !== 0 ? (
                <NewProduct
                  title={t("newProducts", locale)}
                  data={productsNewHome}
                  slug={`/${locale}/${asPath
                    ?.split("/")
                    ?.slice(0, -1)
                    ?.splice(1)
                    ?.toString()
                    ?.replaceAll(",", "/")}`}
                />
              ) : (
                <></>
              )
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  try {
    const { slug } = ctx.query;
    const { auth } = nookies.get(ctx);
    const { locale } = ctx;
    const _slug = slug as string[];

    const authHeaders = auth
      ? {
          authorization: "Bearer " + auth,
        }
      : null;

    const productData = await axios.get(
      baseURL + `/product/${slug![_slug.length - 1]}`,
      {
        headers: {
          "x-localization": locale ? locale : "az",
          ...authHeaders,
        },
        timeout: 10000,
      }
    );

    if (_slug.length === 1) {
      return {
        props: {
          productData: productData.data,
          locale,
          slug,
        },
      };
    }

    return {
      notFound: true,
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
};

const Flex = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  @media (max-width: 480px) {
    justify-content: flex-start;
  }
`;
